export default __webpack_public_path__ + "static/jam-seo-tools-logo-34653e87e25774bdcbcc8c59b3a938f7.png";